import { Button } from "@material-ui/core";

const AddCommentButton = (props) => {
  const { onClick, id, text } = props;
  return (
    <Button variant="contained" onClick={onClick} id={id}>
      {text}
    </Button>
  );
};

export default AddCommentButton;
